import { options } from './constants'

export const getAccessabilityColorsFromColour = (color: string) => {
    const accessabilityColors = options.find(
        (option) => color.includes(option.classStr)
    );

return accessabilityColors;
}

export const getAccessibilityUrlParam = (): string => {
    const option = getAccessabilityColorsFromColour(
        localStorage.getItem('accessabilitySetting') || ''
    );
    const code = option ? option.optionId : 0;
    return `&accessibility=${code}`;
};